














































































































































import { Vue, Component, Prop, Watch } from "vue-property-decorator";
import { Action, State } from "vuex-class";
import SetDispositionMenu from "./SetDispositionMenu.vue";
import { Datetime } from "vue-datetime";
import { objectify } from "@/helpers";
import logger from "@/configs/logger";

import "vue-datetime/dist/vue-datetime.css";

@Component({ components: { SetDispositionMenu, Datetime } })
export default class SetDisposition extends Vue {
  @Prop({ required: true }) taskAttributes!: any;
  @Prop({ required: true }) endCall!: Function;
  @Action("setDisposition") setDisposition!: Function;
  @Action("addCallback") addCallback!: Function;
  @Action("getDispositions") getDispositions!: Function;
  @Action("toggleAgentReady") toggleAgentReady!: Function;

  selectedDisposition: string = "";
  dispositionNote: string = "";
  dispositionNoteAddLoading = false;
  dispositionNoteDialogShow = false;
  dispositionNoteInputError = false;
  dispositionSelectError = false;
  dispositionNoteInputErrorMessage = "Dispositon note is required.";

  dispositions = [];

  datetime = new Date().toISOString();
  minDate = new Date().toISOString();

  @Watch("taskAttributes")
  async onTaskAttributeChange(val: any, prev: any) {
    if (prev === null && val && val.task_creation_source) {
      // when this was called on mount it was possible for taskAttribute to still be null.
      // Therefore the general dispositions will be fetch instead of for the disposition group
      this.dispositions = await this.getDispositions(this.taskAttributes);
    }
  }

  async mounted() {
    logger("log", "taskattributes:", this.taskAttributes);
    this.dispositions = await this.getDispositions(this.taskAttributes);
  }

  get dispositionValues() {
    return this.dispositions.map((val: any) => val.name);
  }

  get dispositionGroup(): string[] {
    return objectify(this.taskAttributes).disposition_options || "";
  }

  get currentDisposition(): any {
    return objectify(this.taskAttributes).disposition;
  }

  get taskCreationSource(): any {
    return objectify(this.taskAttributes).task_creation_source;
  }

  // not prod ready
  // get requiresCallback(): any {
  //   const dispositionObject: any = this.dispositions.find(
  //     (dispo: any) => dispo.name === this.selectedDisposition
  //   );

  //   return objectify(dispositionObject).callback;
  // }

  onSetDisposition(selection: string) {
    this.selectedDisposition = selection;
  }

  showDispositionDialog(): void {
    this.dispositionNoteDialogShow = true;
  }

  cancelDispositionDialog(): void {
    this.dispositionNoteDialogShow = false;
  }

  requiresDispositionNote(disposition: string, ignoreDisposition: boolean) {
    const task = objectify(this.taskAttributes);
    const taskCreationSource = task.task_creation_source;
    const leadSource = task.lead_source;

    if (ignoreDisposition) {
      return false;
    }

    if (leadSource == "platinum" || leadSource == "raw_dialer_callback") {
      return false;
    }

    if (
      taskCreationSource == "outbound_dial" ||
      taskCreationSource == "agent_callback"
    ) {
      return false;
    }

    if (taskCreationSource === "vendor_transfer") {
      return true;
    }

    return true;
    // const dispositionObject: any = this.dispositions.find(
    //   (dispo: any) => dispo.name === this.selectedDisposition
    // );

    // return objectify(dispositionObject).requiresNote;

    /**
     * if (objectify(this.taskAttributes).require_disposition_note) {
      return true;
    }
    const dispositionInfo: any = this.dispositions.find(
      (item: any) => item.name == disposition
    );
    if (dispositionInfo) {
      return dispositionInfo.requiresNote;
    }
    return false;
     */
  }

  async onQuickDisposition(disposition: string) {
    try {
      this.endCall();
      this.selectedDisposition = disposition;
      await this.submitDisposition(true);
    } catch (err) {
      logger("log", "quick disposition error:", err);
    }
  }

  async submitDispositionAndGoOffline() {
    try {
      this.toggleAgentReady(false);
      await this.submitDisposition(false);
    } catch (err) {
      logger("log", "submit disposition and go offline error:", err);
    }
  }

  async submitDisposition(ignoreDisposition: boolean): Promise<void> {
    logger("log", "submit disposition", this.taskAttributes.id);
    try {
      if (!this.selectedDisposition) {
        this.dispositionSelectError = true;
      } else if (
        this.requiresDispositionNote(
          this.selectedDisposition,
          ignoreDisposition
        ) &&
        this.dispositionNote === ""
      ) {
        this.dispositionNoteInputError = true;
      } else {
        this.dispositionNoteAddLoading = true;
        this.dispositionNoteInputError = false;
        this.dispositionSelectError = false;

        const attributes = this.taskAttributes;
        await this.setDisposition({
          disposition: this.selectedDisposition,
          disposition_note: this.dispositionNote,
          taskId: this.taskAttributes.id
        });

        logger("info", "before callback set", this.selectedDisposition);
        if (this.selectedDisposition === "Call Back") {
          logger("info", "setting callback", this.selectedDisposition);
          await this.addCallback({
            time: this.datetime,
            leadName: attributes.lead_name,
            leadKey: attributes.lead_key,
            userKey: attributes.reservation_user_key
          });
        }

        this.dispositionNoteAddLoading = false;
        this.dispositionNoteDialogShow = false;
      }
    } catch (err) {
      logger("error", "set disposition error", err);
      this.dispositionNoteAddLoading = false;
      this.dispositionNoteDialogShow = false;
    }
  }
}
